var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdobeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_896_7852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 0H33.6667C37.5833 0 40.75 3.24786 40.75 7.26496V32.735C40.75 36.7521 37.5833 40 33.6667 40H7.83333C3.91667 40 0.75 36.7521 0.75 32.735V7.26496C0.75 3.24786 3.91667 0 7.83333 0Z",
    fill: "#EB1000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.85 30.0855H27.1C26.6834 30.0855 26.3 29.8462 26.1334 29.4359L20.9834 17.0598C20.95 16.9402 20.8167 16.8718 20.7 16.906C20.6334 16.9231 20.5667 16.9915 20.55 17.0598L17.3334 24.906C17.2667 25.0427 17.3334 25.2137 17.4834 25.265C17.5167 25.2821 17.55 25.2821 17.5834 25.2821H21.1167C21.3334 25.2821 21.5334 25.4188 21.6167 25.6239L23.1667 29.1624C23.3 29.4872 23.15 29.8803 22.8334 30.0171C22.75 30.0513 22.6667 30.0684 22.5834 30.0684H9.70003C9.38337 30.0684 9.1167 29.7949 9.1167 29.4701C9.1167 29.3846 9.13337 29.3162 9.1667 29.2308L17.35 9.24787C17.5167 8.82052 17.9334 8.52992 18.3834 8.54701H23.1C23.55 8.54701 23.9667 8.82052 24.1334 9.24787L32.3834 29.2308C32.5167 29.5385 32.3667 29.8974 32.0834 30.0171C32 30.0513 31.9334 30.0684 31.85 30.0855Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_896_7852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeLogo);
export default __webpack_public_path__ + "static/media/adobe-logo.278ed473fde15c468c848108c142c5cb.svg";
export { ForwardRef as ReactComponent };